import styles from './FormGroup.module.css';

export function FormGroup({ label, required = false, children }) {
  return (
    <div className={styles.group}>
      {label && (
        <label className={styles.label}>
          {label}
          {required && <span className={styles.req}> *</span>}
        </label>
      )}
      {children}
    </div>
  );
}
